/* eslint-disable react/no-unstable-nested-components */
import React from 'react'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Hooks
// import { useFetchTransfer } from 'core/hooks/api'

// Styled Elements
import {
  TableButtonWrapper,
  TableRowWrapper,
  TableColWrapper,
  TableRowContainer,
  IconPlaceholder,
} from './TransactionsTableItemLoading.elements'

// Views
import { AccordionTableItem, RiskBar, TextLoading } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = (dispatch) => actions(dispatch)

function TransactionsTableItemLoading() {
  return (
    <AccordionTableItem
      setIsExpanded={() => {}}
      expandPanel={false}
      button={
        <TableButtonWrapper>
          <TableRowWrapper>
            <TableRowContainer>
              <IconPlaceholder />
              <TextLoading height={18} width={150} />
            </TableRowContainer>

            <TableRowContainer>
              <TextLoading height={18} width={120} />
            </TableRowContainer>
          </TableRowWrapper>

          <TableRowWrapper>
            <TableRowContainer>
              <TextLoading height={18} width={50} />
              <RiskBar width={0} />
            </TableRowContainer>

            <TableRowContainer>
              <TableColWrapper style={{ gap: '5px' }}>
                <TextLoading height={17} width={50} />
                <TextLoading height={12} width={30} />
              </TableColWrapper>
            </TableRowContainer>
          </TableRowWrapper>
        </TableButtonWrapper>
      }
      panel={<div />}
    />
  )
}

// Default Props
TransactionsTableItemLoading.defaultProps = {}

// Proptypes Validation
TransactionsTableItemLoading.propTypes = {}
export default connect(mapStateToProps, mapDispatchToProps)(TransactionsTableItemLoading)
